import styled from 'styled-components';

// Matches PropTextInput styling from ComponentPage for visual consistency
export const Wrapper = styled.div`
	position: relative;
	overflow: visible;
	min-width: 150px;
`;

export const Input = styled.input`
	padding: 8px 12px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 6px;
	min-width: 150px;
	width: 100%;
	box-sizing: border-box;
	transition: all 0.2s ease;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}

	&::placeholder {
		color: ${({ theme }) => theme.gray[400]};
	}
`;

export const Dropdown = styled.div`
	position: absolute;
	top: 100%;
	left: 0;
	right: 0;
	background: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 8px;
	z-index: 1000;
	display: flex;
	flex-direction: column;
	margin-top: 4px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const DropdownList = styled.div`
	max-height: 264px;
	overflow-y: auto;
`;

export const DropdownItem = styled.div<{ $active?: boolean }>`
	padding: 8px 12px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ theme, $active }) => ($active ? theme.gray[200] : 'transparent')};

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
`;

export const BrowseLink = styled.a`
	display: block;
	padding: 10px 12px;
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	text-align: center;
	border-top: 1px solid ${({ theme }) => theme.gray[200]};
	text-decoration: none;
	background: ${({ theme }) => theme.gray[200]};

	&:hover {
		color: ${({ theme }) => theme.gray[700]};
		background: ${({ theme }) => theme.gray[200]};
	}
`;
